<template>
    <div class="col-12 px-0 mt-2">
        <div v-if="introduction.length > 0" class="col-12">
            <div class="row">
                <div class="col-12" v-for="c in introduction" :key="c.id">
                    <chapter :chapter="c"  />
                </div>
            </div>
        </div>
        <div v-if="competences.length > 0" class="col-12 px-0 px-sm-3">
            <competences :chapters="competences" />
        </div>
        <div v-if="missions.length > 0" class="col-12">
            <div class="row">
                <div class="col-12" v-for="c in missions" :key="c.id">
                    <chapter :chapter="c" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Chapter from "../molecules/Chapter";
    import Competences from "./Competences";

    export default {
        components: {Competences, Chapter},
        props: {
            introduction: Array,
            competences: Array,
            missions: Array,
            type: String
        },
    }
</script>
